module.exports = __webpack_public_path__ + "static/1-17b608535ce99e5cd566749338f5d955.jpg";